<template>
  <div>
    <q-dialog
      @update:model-value="(value) => $emit('update:modalValue', value)"
      :model-value="props.modelValue"
    >
      <q-card
        class="text-brand-5 text-weight-bold"
        style="height: 630px; max-width: 900px; width: 900px"
      >
        <q-card-section>
          <section class="row align justify-between">
            <div class="text-h6">
              {{
                props.tipoCadastro ? "Cadastro Facial" : "Verificação Facial"
              }}
            </div>
            <q-btn
              round
              color="negative"
              flat
              icon="close"
              @click="$emit('close', false), pause()"
            />
          </section>
        </q-card-section>
        <q-separator />

        <div class="print-container">
          <q-icon
            name="verified"
            v-if="sendSucess"
            color="positive"
            class="q-mt-xl"
            size="200px"
          />
          <div class="face-indicator" v-if="esconderCaptura"></div>

          <video
            v-if="esconderCaptura"
            class="faceCapture q-mt-md"
            autoplay
          ></video>
          <q-btn
            v-if="esconderCaptura"
            :disable="!props.userId"
            label="Capturar"
            class="q-mt-md q-ml-sm"
            color="secondary"
            icon="visibility"
            @click="screenShot"
          />

          <canvas
            v-show="!esconderCaptura && sendSucess != true"
            style="height: 40%; width: 40%; border-radius: 15px"
            class="canvasFace q-mt-md"
          ></canvas>
          <div v-if="!esconderCaptura" class="row q-mt-md container-buttons">
            <q-btn
              v-if="sendSucess != true && props.tipoCadastro"
              :disable="!props.userId"
              label="CONFIRMAR CADASTRO"
              class="q-ml-sm mobile-button"
              color="positive"
              icon="add"
              @click="cadastrarFace"
            />
            <q-btn
              v-if="sendSucess != true && !props.tipoCadastro"
              :disable="!props.userId"
              label="CONFIRMAR FACE"
              class="q-ml-sm mobile-button"
              color="positive"
              icon="add"
              @click="$emit('sendFace', faceSend), pause()"
            />

            <q-btn
              :disable="!props.userId"
              label="Tirar novamente"
              class="q-ml-sm mobile-button mobile-button-last"
              color="secondary"
              icon="refresh"
              @click="screenRepeat"
            />
          </div>
        </div>
        <span class="row justify-end">
          <q-btn
            v-if="esconderCaptura"
            round
            icon="flip_camera_android"
            color="primary"
            class="q-ma-md"
            @click="toggleCamera"
          />
        </span>
      </q-card>
    </q-dialog>
  </div>
</template>

<script setup>
import { defineProps, defineEmits } from "vue";
import { ref, onMounted, watch } from "vue";
import { useStore } from "vuex";
import { useQuasar } from "quasar";

const props = defineProps({
  modelValue: {
    type: Boolean,
    required: true,
  },
  userId: {
    type: [Number, String],
  },
  tipoCadastro: {
    type: Boolean,
    default: false,
  },
});

const emit = defineEmits([
  "update:modalValue",
  "close",
  "sendFace",
  "atualizarFacial",
]);

const store = useStore();
const quasar = useQuasar();
const stream = ref(null);
const devicesList = ref([]);
const sendSucess = ref(false);

const esconderCaptura = ref(false);
const faceSend = ref(null);
const faceList = ref([]);
let currentDeviceIndex = ref(0);

const contrains = ref({
  video: {
    facingMode: "user",
    width: {
      min: 1280,
      ideal: 1920,
      max: 1920,
    },
    height: {
      min: 720,
      ideal: 1080,
      max: 1080,
    },
  },
});

const screenShot = async () => {
  const canvas = document.querySelector(".canvasFace");
  const video = document.querySelector(".faceCapture");

  if (!canvas || !video) {
    console.error("Canvas ou vídeo não encontrados");
    return;
  }

  // Definir as dimensões do recorte
  const targetWidth = 960;
  const targetHeight = 1280;

  // Calcular as dimensões de origem e o fator de escala para manter a proporção correta
  const sourceWidth = video.videoWidth;
  const sourceHeight = video.videoHeight;
  const sourceAspect = sourceWidth / sourceHeight;
  const targetAspect = targetWidth / targetHeight;

  let drawWidth, drawHeight, startX, startY;

  if (sourceAspect > targetAspect) {
    // A imagem de origem é mais larga do que a proporção alvo
    drawHeight = sourceHeight;
    drawWidth = sourceHeight * targetAspect;
    startX = (sourceWidth - drawWidth) / 2;
    startY = 0;
  } else {
    // A imagem de origem é mais alta do que a proporção alvo
    drawWidth = sourceWidth;
    drawHeight = sourceWidth / targetAspect;
    startX = 0;
    startY = (sourceHeight - drawHeight) / 2;
  }

  // Ajustar o canvas para as dimensões desejadas
  canvas.width = targetWidth;
  canvas.height = targetHeight;
  const ctx = canvas.getContext("2d");

  // Desenhar a imagem do vídeo no canvas, recortando-a
  ctx.drawImage(
    video,
    startX,
    startY,
    drawWidth,
    drawHeight,
    0,
    0,
    targetWidth,
    targetHeight
  );

  // Converter a imagem do canvas para JPEG com qualidade de 0.9
  faceSend.value = canvas.toDataURL("image/jpeg", 0.9);

  esconderCaptura.value = false;
};

const getDevices = async () => {
  try {
    const devices = await navigator.mediaDevices.enumerateDevices();
    devicesList.value = devices.filter(
      (d) => d.kind === "videoinput" && d.deviceId
    );
  } catch (error) {
    console.error("Erro ao obter dispositivos:", error);
  }
};

const toggleCamera = async () => {
  if (devicesList.value.length < 2) return;

  // Avança o índice circularmente
  currentDeviceIndex.value =
    (currentDeviceIndex.value + 1) % devicesList.value.length;

  const selectedDeviceId = devicesList.value[currentDeviceIndex.value].deviceId;

  // Encerra as trilhas da câmera atual
  if (stream.value) {
    stream.value.getTracks().forEach((track) => track.stop());
  }

  try {
    // Solicita câmera com o deviceId selecionado
    stream.value = await navigator.mediaDevices.getUserMedia({
      video: { deviceId: { exact: selectedDeviceId } },
    });

    const video = document.querySelector(".faceCapture");
    if (video) {
      video.srcObject = stream.value;
      await video.play();
    }
  } catch (err) {
    console.error("Erro ao alternar câmera:", err);
  }
};

const screenRepeat = async () => {
  sendSucess.value = false;
  esconderCaptura.value = true;

  if (stream.value) {
    stream.value.getTracks().forEach(function (track) {
      track.stop();
    });
  }

  try {
    if (
      "mediaDevices" in navigator &&
      "getUserMedia" in navigator.mediaDevices
    ) {
      stream.value = await navigator.mediaDevices.getUserMedia({
        ...contrains.value,
      });
      const video = document.querySelector(".faceCapture");
      if (video) {
        video.srcObject = stream.value;
        await video.play();
      }
    }
  } catch (error) {
    console.error("Erro ao reiniciar câmera:", error);
  }
};

const screenInit = async () => {
  sendSucess.value = false;
  esconderCaptura.value = true;

  try {
    await new Promise((resolve) => setTimeout(resolve, 500));

    const video = document.querySelector(".faceCapture");

    if (!video) {
      console.error("❌ Elemento video não encontrado!");
      throw new Error("Elemento video não encontrado");
    }

    stream.value = await navigator.mediaDevices.getUserMedia({
      video: true,
    });

    video.srcObject = stream.value;
    await video.play();

    // Depois da permissão, agora sim pode listar os devices corretamente
    await getDevices();

    // Atualiza para o primeiro device (opcional)
    currentDeviceIndex.value = 0;
  } catch (err) {
    console.error("Erro ao iniciar vídeo:", err);
    esconderCaptura.value = true;
  }
};

const pause = async () => {
  if (stream.value) {
    stream.value.getTracks().forEach(function (track) {
      track.stop();
    });
  }
};

const cadastrarFace = async () => {
  if (!faceSend.value) {
    quasar.notify({
      message: "Nenhuma imagem capturada",
      color: "negative",
    });
    return;
  }

  quasar.loading.show();
  try {
    await store.dispatch("user/cadastrarFacial", {
      usuarioId: props.userId,
      biometria: faceSend.value,
    });

    quasar.notify({
      message: "Rosto cadastrado com sucesso",
      color: "positive",
    });

    sendSucess.value = true;

    emit("sendFace", faceSend.value);

    emit("atualizarFacial");

    setTimeout(() => {
      pause();
      emit("close", false);
    }, 2000);
  } catch (error) {
    console.error("Erro ao cadastrar facial:", error);
    quasar.notify({
      message: "Erro ao cadastrar rosto",
      color: "negative",
    });
  } finally {
    quasar.loading.hide();
  }
};

onMounted(getDevices);

watch(
  () => props.modelValue,
  async (newValue) => {
    if (newValue === true) {
      await screenInit();
      faceList.value = [];
    } else {
      await pause();
    }
  },
  { immediate: true }
);
</script>

<style scoped>
.print-container {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}
.align {
  text-align: center;
}
a {
  text-decoration: none;
}

video {
  width: 61%;
  height: 40%;
  border-radius: 15px;
}

@keyframes rotate {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}

.face-indicator {
  width: 200px;
  height: 200px;
  background-color: transparent;
  margin-bottom: 15px;
  z-index: 9999;
  position: absolute;
  border: dashed 7px #58c16d;
  border-radius: 100%;
  animation: rotate 6s linear infinite;
}

@media (max-width: 762px) {
  .face-indicator {
    width: 150px;
    height: 150px;
  }
}

@media (max-width: 586px) {
  .face-indicator {
    width: 100px;
    height: 100px;
  }

  .container-buttons {
    justify-content: space-around;
  }
  .mobile-button-last {
    margin-top: 15px;
  }
}

@media (max-width: 412px) {
  .face-indicator {
    width: 70px;
    height: 70px;
  }
}
</style>
